import { SET_HUMANS_FILTER_QUERY } from "../actions/humans";

const DEFAULT_VALUE = { searchTerm: "", circle: null };

export default function humansFilterQuery(state = DEFAULT_VALUE, action) {
  switch (action.type) {
    case SET_HUMANS_FILTER_QUERY:
      return { ...state, ...action.query };

    default:
      return state;
  }
}
